// Mock data and handlers for Unique Pro Cleaning website

export const mockQuoteRequests = [];

export const submitQuoteRequest = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const newRequest = {
        id: Date.now().toString(),
        ...formData,
        submittedAt: new Date().toISOString(),
        status: 'pending'
      };
      mockQuoteRequests.push(newRequest);
      resolve({
        success: true,
        message: 'Quote request submitted successfully! We will contact you soon.',
        data: newRequest
      });
    }, 800);
  });
};

export const servicesData = [
  {
    id: 'residential',
    title: 'Residential Cleaning',
    description: 'Keep your home spotless with our thorough residential cleaning services. From weekly maintenance to deep cleans, we handle it all.',
    icon: 'Home',
    image: 'https://images.pexels.com/photos/6195285/pexels-photo-6195285.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  {
    id: 'commercial',
    title: 'Commercial Cleaning',
    description: 'Professional office and commercial space cleaning to maintain a pristine work environment for your team and clients.',
    icon: 'Building2',
    image: 'https://images.unsplash.com/photo-1437326300822-01d8f13c024f'
  },
  {
    id: 'deep',
    title: 'Deep Cleaning',
    description: 'Intensive cleaning service that reaches every corner. Perfect for seasonal refreshes or special occasions.',
    icon: 'Sparkles',
    image: 'https://images.unsplash.com/photo-1742483359033-13315b247c74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxyZXNpZGVudGlhbCUyMGNsZWFuaW5nfGVufDB8fHx8MTc3NTUxODI4Nnww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'move',
    title: 'Move-In / Move-Out Cleaning',
    description: 'Comprehensive cleaning for moving transitions. Leave your old space spotless or step into a fresh, clean new home.',
    icon: 'TruckIcon',
    image: 'https://images.unsplash.com/photo-1736433622548-4adbbc1c2cf2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxraXRjaGVuJTIwY2xlYW5pbmd8ZW58MHx8fHwxNzc1NTE4MjkxfDA&ixlib=rb-4.1.0&q=85'
  }
];

export const whyChooseUsData = [
  {
    icon: 'MapPin',
    title: 'Locally Focused Service',
    description: 'Proudly serving Columbus, Ohio and surrounding communities with personalized attention.'
  },
  {
    icon: 'Shield',
    title: 'Reliable and Professional',
    description: 'Consistent, dependable service you can count on, every time.'
  },
  {
    icon: 'CheckCircle',
    title: 'Detail-Oriented Cleaning',
    description: 'We don\'t cut corners. Every surface gets the attention it deserves.'
  },
  {
    icon: 'Calendar',
    title: 'Flexible Scheduling',
    description: 'Work around your schedule with convenient appointment times.'
  },
  {
    icon: 'Award',
    title: 'Quality Results',
    description: 'Exceptional cleaning standards that exceed expectations.'
  },
  {
    icon: 'Heart',
    title: 'Customer-First Approach',
    description: 'Your satisfaction is our top priority. We listen and deliver.'
  }
];
